module.exports = __webpack_public_path__ + "static/media/Internationalcase7.b5af3053.png";